import { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';

import { gameResourcesService } from '../../services/gameResourcesService';
import { gameConfigurationStore } from '../../store/gameConfigurationStore';
function WinLine() {
  const winLineContainerRef = useRef(null);
  const { symbolsSizes, reelsContainerParams } = gameConfigurationStore;

  const containerConfig = {
    x: reelsContainerParams.xInFigma,
    y: reelsContainerParams.yInFigma + symbolsSizes.height / 2,
  }

    useEffect(() => {
      if (winLineContainerRef.current) gameResourcesService.setupAllLine(winLineContainerRef.current);
    }, [winLineContainerRef]);

  return <Container visible ref={winLineContainerRef} {...containerConfig} name='WinLine' />;
}

export default WinLine;
